import { useQuery } from 'react-query';
import { getUserId } from '../../../../DefaultService';
import { IPaginationParams } from '../../../../types';
import { getSportButtonEventsAsync, getSportButtonEventsCountAsync } from '../../index';
import { ISportButtonEventFilterParams } from '../../types';

const USER_ID = getUserId();

export const SPORT_BUTTON_EVENTS_KEYS = {
  ALL: 'sportButtonEvents',
  LIST: 'list',
  COUNT: 'count',
};

export const useGetAllSportButtonEventsQuery = (
  pagination: IPaginationParams,
  filter: ISportButtonEventFilterParams,
) =>
  useQuery(
    [SPORT_BUTTON_EVENTS_KEYS.ALL, SPORT_BUTTON_EVENTS_KEYS.LIST, pagination, filter, USER_ID],
    {
      keepPreviousData: true,
      staleTime: 1000 * 30,
      queryFn: () => getSportButtonEventsAsync(pagination, filter),
    },
  );

export const useGetSportButtonEventsCountQuery = (filter: ISportButtonEventFilterParams) =>
  useQuery(
    [SPORT_BUTTON_EVENTS_KEYS.ALL, SPORT_BUTTON_EVENTS_KEYS.COUNT, filter, USER_ID],
    {
      keepPreviousData: true,
      staleTime: 1000 * 30,
      queryFn: () => getSportButtonEventsCountAsync(filter),
    },
  );
